/**
 * Constants for video state management and asset type identification
 */

/**
 * Asset type string constants
 * These correspond to the simplified asset type representations used throughout the video state system
 */
export const ASSET_TYPES = {
    TEXT: 'TEXT',
    READONLY_TEXT: 'READONLY_TEXT',
    FANCY_CAPTION: 'FANCY_CAPTION',
    CAPTION: 'CAPTION',
    MEDIA: 'MEDIA',
    READONLY_MEDIA: 'READONLY_MEDIA',
    ICON: 'ICON',
    READONLY_ICON: 'READONLY_ICON',
    STICKER: 'STICKER',
    BACKGROUND: 'BACKGROUND',
    GROUP: 'GROUP',
    WATERMARK: 'WATERMARK',
} as const;

/**
 * Type for asset type string values
 */
export type AssetType = (typeof ASSET_TYPES)[keyof typeof ASSET_TYPES];

/**
 * Scene group type string constants
 * These correspond to the different types of scene groups in the video
 */
export const SCENE_GROUP_TYPES = {
    REGULAR: 'regular',
    VOICEOVER: 'voiceover',
    TALKING_HEAD: 'talking_head',
    AVATAR: 'avatar',
} as const;

/**
 * Type for scene group type string values
 */
export type SceneGroupType = (typeof SCENE_GROUP_TYPES)[keyof typeof SCENE_GROUP_TYPES];

/**
 * Message returned in place of a video state when no video has been created yet
 * (i.e. the video has no scenes). Surfacing this instead of an empty diff keeps
 * agents from treating a not-yet-created video as if it existed.
 */
export const NO_VIDEO_STATE_MESSAGE =
    'There is no video yet. No video has been created, so there is no video state to show.';
